import { render, staticRenderFns } from "./ModalTransferLicence.vue?vue&type=template&id=2763831b&scoped=true&"
import script from "./ModalTransferLicence.vue?vue&type=script&lang=js&"
export * from "./ModalTransferLicence.vue?vue&type=script&lang=js&"
import style0 from "./ModalTransferLicence.vue?vue&type=style&index=0&id=2763831b&prod&lang=scss&scoped=true&"
import style1 from "./ModalTransferLicence.vue?vue&type=style&index=1&id=2763831b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763831b",
  null
  
)

export default component.exports